export const defaultModules = {
  toolbar: [
    [{ header: [1, 2, false] }],
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
    [{ script: 'sub' }, { script: 'super' }],
    [{ color: [] }, { background: [] }],
    ['link', 'image'],
    ['clean'],
  ],
};

export interface RichTextEditorProps {
  value: string;
  onValueChange?: (value: string) => void;
  modules?: Record<string, unknown>;
  readOnly?: boolean;
  placeholder?: string;
  error?: boolean;
  htmlId?: string;
  ariaLabel?: string;
  ariaDescribedBy?: string;
}
